// extracted by mini-css-extract-plugin
export var badge = "Teaser-module--badge--II824";
export var component = "Teaser-module--component--UXcfM";
export var content = "Teaser-module--content--Mv7BV";
export var inner = "Teaser-module--inner--coU5g";
export var media = "Teaser-module--media--AeqXf";
export var meta = "Teaser-module--meta--dxJ+U";
export var title = "Teaser-module--title--t2wCM";